import React from 'react'
import Header from '../../components/global/Header'
import styles from "../../asset/css/daoPage.module.css";
import { Images } from '../../data/Images';
export default function DaoPage() {
    return (
        <div className={`${styles.deoPage} homePagelayout`}>
            <Header />
            <section className={styles.tokenomicsSection}>
                <div className={styles.titlePart}>
                    <h2 className={"madani_arabic_bold"}>DAO</h2>
                    <h3>Decentralized Governance for Nexus Launchpad: Community-Driven Token Listings
                    </h3>
                    <p>Nexus Launchpad can integrate a Decentralized Autonomous Organization (DAO) to empower the community in the token listing process, ensuring fairness, transparency, and high-quality project selection. Here’s how it can work:
                    </p>
                </div>
                <div className={styles.contentPart}>
                    <div className={styles.keyAspectsCardWrapper}>
                        <div className={styles.keyAspectCardPart}>
                            <div className={styles.cardHeader}>
                                <img src={Images.tokenomicsIcon1} alt='tokenomics' />
                                <h3>DAO Structure & Governance Token</h3>
                            </div>
                            <div className={styles.cardBody}>
                                <ul>
                                    <li>
                                        The launchpad introduces a governance token ($NXUS) that grants voting rights to holders.

                                    </li>
                                    <li>
                                        Token holders participate in governance proposals related to project listings, launchpad fees, and platform upgrades.
                                    </li>
                                    <li>
                                        Staked or governance tokens $NXUS will be used for voting power.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={styles.keyAspectCardPart}>
                            <div className={styles.cardHeader}>
                                <img src={Images.tokenomicsIcon2} alt='tokenomics' />
                                <h3>Community-Driven Token Listings                               </h3>
                            </div>
                            <div className={styles.cardBody}>
                                <ul>
                                    <li>
                                        <strong>Project Submission:</strong> New projects apply for a launch on Nexus, providing detailed information, audits, and tokenomics.

                                    </li>
                                    <li>
                                        <strong> DAO Review & Discussion:</strong> The community reviews project proposals, discusses potential risks, and engages in AMA sessions with founders.

                                    </li>
                                    <li>
                                        <strong>Voting Mechanism:</strong> Token holders vote on whether a project gets listed on the launchpad. Projects must meet a predefined voting threshold (e.g., majority approval) to proceed.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={styles.keyAspectCardPart}>
                            <div className={styles.cardHeader}>
                                <img src={Images.tokenomicsIcon4} alt='tokenomics' />
                                <h3>Weighted & Sybil-Resistant Voting</h3>
                            </div>
                            <div className={styles.cardBody}>
                                <ul>
                                    <li>
                                        Voting power is proportional to governance token holdings, but mechanisms like quadratic voting can be implemented to prevent whales from dominating decisions
                                    </li>
                                    <li>
                                        Staking governance tokens for voting may be required to prevent spam and ensure commitment.

                                    </li>
                                    <li>
                                        Stakers and active voters may receive rewards from treasury funds in the form of $Rubix, USDC, or other assets.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={styles.keyAspectCardPart}>
                            <div className={styles.cardHeader}>
                                <img src={Images.tokenomicsIcon5} alt='tokenomics' />
                                <h3>Transparency & Security</h3>
                            </div>
                            <div className={styles.cardBody}>
                                <ul>
                                    <li>
                                        Votes and decisions are recorded on-chain, ensuring transparency and preventing manipulation.

                                    </li>
                                    <li>
                                        AI-powered risk assessment tools can supplement voting decisions by flagging high-risk projects based on data analysis.

                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={styles.keyAspectCardPart}>
                            <div className={styles.cardHeader}>
                                <img src={Images.tokenomicsIcon6} alt='tokenomics' />
                                <h3>DAO Treasury & Incentives
                                </h3>
                            </div>
                            <div className={styles.cardBody}>
                                <ul>
                                    <li>
                                        A community treasury collects a portion of launchpad fees, and the DAO votes on fund allocation (e.g., rewards, marketing, ecosystem growth).
                                    </li>
                                    <li>
                                        Active voters and contributors can receive staking rewards or governance incentives.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className={styles.footerPart}>
                        <p>
                            Nexus Launchpad becomes truly decentralized, allowing the community to decide which projects get launched, ensuring fairness, accountability, and trust in the ecosystem.
                        </p>
                    </div>
                </div>
                <div className={styles.tokenBgPatten}>
                    <img className={styles.daoPattenImg1} src={Images.daoPattenImg1} alt="circle Shape" />
                    <img className={styles.daoPattenImg2} src={Images.daoPattenImg2} alt="circle Shape" />
                    <img className={styles.daoPattenImg3} src={Images.daoPattenImg3} alt="circle Shape" />
                    <img className={styles.daoPattenImg4} src={Images.daoPattenImg4} alt="circle Shape" />
                    <img className={styles.daoPattenImg5} src={Images.daoPattenImg5} alt="circle Shape" />
                </div>
            </section>
        </div>
    )
}
